import React from 'react';
import { injectIntl } from '../../localization';
import { prices } from '../../utils/configs';

const PriceCopy = ({ className, intl }) => {
  const defaultMessages = {
    PriceCopy: {
      id: 'priceCopy',
      defaultMessage: '3-day trial for €{trialPrice}, then €{subscriptionPrice}/month with automatic renewal'
    }
  };

  return (
    <div className={`${className || ''}`}>
      {intl
        .formatMessage(defaultMessages.PriceCopy)
        .replace('{trialPrice}', prices.trialPrice)
        .replace('{subscriptionPrice}', prices.subscriptionPrice)}
    </div>
  );
};

export default injectIntl(PriceCopy);
